module.exports = __webpack_public_path__ + "img/344.cd1acb28.jpg";